import { Navigate } from 'react-router-dom'
import { isLoggedIn, hasSidebar } from '../../utils'
import PrivateRoute from '../PrivateRoute/PrivateRoute'
import PageTop from '../PageTop/PageTop'
import AreaSidebar from '../AreaSidebar/AreaSidebar'

export default function CommonComponents() {
  const sidebarComponent = hasSidebar() ? <PrivateRoute path="/" component={AreaSidebar} /> : null
  return isLoggedIn() ? (<><PrivateRoute path="/" component={PageTop} />{sidebarComponent}</>) : (<Navigate to="/login" />)
}
